export default __webpack_public_path__ + "static/media/virtual-item.9aae6c5d.png";